import {apiTransactionsRequests} from '#/repository/api-transactions-requests';
import {ApiTransactions} from '@shareland/shareland-common';
import {UseQueryOptions, useInfiniteQuery} from '@tanstack/react-query';

type PageParam = Awaited<ReturnType<typeof apiTransactionsRequests.getLatest>> & {page: number};

const getNextPageParam = (lastPage: PageParam, take: number) => {
  const hasNextPage = (lastPage.page - 1) * take + lastPage.results.length >= lastPage.total;
  return hasNextPage ? undefined : lastPage.page + 1;
};

export const useLatestApiTransactions = (
  params: Omit<ApiTransactions['getLatest']['reqQuery'], 'page'> & Pick<UseQueryOptions, 'enabled'>,
) => {
  const {landTokenSymbol, account, take, enabled = true} = params;

  return useInfiniteQuery({
    queryKey: ['api-transactions-get-latest', landTokenSymbol, account, `take-${take}`],
    queryFn: async ({pageParam}) => {
      const res = await apiTransactionsRequests.getLatest({
        ...(landTokenSymbol && {landTokenSymbol}),
        ...(account && {account}),
        page: pageParam,
        take,
      });
      return {...res, page: pageParam};
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage: PageParam) => getNextPageParam(lastPage, take),
    enabled: enabled as boolean,
  });
};
